import { EventType } from '../enums';
import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { ICopilotServiceApplication } from '../CopilotService.interface';

export class CopilotServiceReadyEvent implements IEvent {
	public static EventType: string = EventType.COPILOT_SERVICE_READY_EVENT;

	public readonly timestamp: Date;
	public readonly eventType = CopilotServiceReadyEvent.EventType;
	public copilotServiceApplication: ICopilotServiceApplication;

	constructor(copilotServiceApplication: ICopilotServiceApplication) {
		this.timestamp = new Date();
		this.copilotServiceApplication = copilotServiceApplication;
	}
}
